/* import __COLOCATED_TEMPLATE__ from './action-button-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();